module.exports = __webpack_public_path__ + "images/anwbvoordezaak_small05ad530e53d8fe6a80b0142567576a80.png";